<template>
  <div>
    <PageHeader :title="$t('Navigation.Training')" />

    <TrainingResources
      :show-sales-guide="!hasExternalPosOnlySubscription"
      :show-seats-furniture-guides="hasSeatsOrFurniture"
      :show-bv-warranty-extension-guides="hasBvWarrantyExtension"
      :training-modules="trainingModules"
      @open-module="openModule"
    />
  </div>
</template>

<script>
import { TrainingResources, PageHeader } from "@estaly/ui";
import { mapActions, mapGetters, mapState } from "vuex";

export default {
  name: "Training",
  components: {
    TrainingResources,
    PageHeader,
  },
  computed: {
    ...mapGetters("businessVerticals", [
      "hasExternalPosOnlySubscription",
      "hasSeatsOrFurniture",
      "hasBvWarrantyExtension",
    ]),
    ...mapState("store", ["selectedStoreId"]),
    ...mapState("trainingModules", ["trainingModules"]),
  },
  watch: {
    selectedStoreId: {
      immediate: true,
      handler() {
        this.fetchBusinessVerticals();
        this.loadTrainingModules();
      },
    },
  },
  methods: {
    ...mapActions("businessVerticals", ["fetchIndex"]),
    ...mapActions("trainingModules", { fetchTrainingModules: "fetchIndex" }),
    async fetchBusinessVerticals() {
      if (Number(this.selectedStoreId) > 0) {
        await this.fetchIndex({ storeId: [this.selectedStoreId], enabled: true });
      }
    },
    async loadTrainingModules() {
      if (Number(this.selectedStoreId) > 0) {
        await this.fetchTrainingModules([this.selectedStoreId]);
      }
    },
    openModule(trainingModule) {
      this.$router.push(`/pos/training/module/${trainingModule.id}`);
    },
  },
};
</script>
